import { useQuery } from '@apollo/client/react';
import { useAtomValue } from 'jotai';
import { useParams } from 'react-router-dom';

import { GET_LIST_OF_FILES } from 'queries';
import { sessionTokenState } from 'states/app';

const useGetListFiles = () => {
  const { accessReportId } = useParams();
  const sessionToken = useAtomValue(sessionTokenState);

  const { loading, error, data } = useQuery(GET_LIST_OF_FILES, {
    variables: { accessReportId, sessionToken: sessionToken?.value },
  });

  return { data, error, loading };
};

export default useGetListFiles;
